import gql from 'graphql-tag'
import { makesQueries } from 'data/graphql'
import { compose, withState } from 'recompose'

const integrationActivityTargetsQuery = gql`
  query getIntegrationActivityTargets($integrationId: ID!) {
    getIntegration(id: $integrationId) {
      activityTargets {
        label
        value
      }
    }
  }
`

export default function withIntegrationActivityTargets() {
  return compose(
    withState('activityTargets', 'setActivityTargets', []),
    withState('activityTargetsLoaded', 'setActivityTargetsLoaded', false),
    makesQueries({
      query: integrationActivityTargetsQuery,
      mapPropsToVariables: ({ integration }) => ({
        integrationId: integration.id,
      }),
      getOnResultFromProps({ setActivityTargets, setActivityTargetsLoaded }) {
        return function providesIntegrationDetailsOnResult({ result }) {
          if (result.data.getIntegration.activityTargets.length > 0) {
            setActivityTargets([
              { label: 'Select a #channel', value: '' },
              ...result.data.getIntegration.activityTargets,
            ])
          }

          setActivityTargetsLoaded(true)
        }
      },
      getOnErrorFromProps({
        setActivityTargets,
        setActivityTargetsLoaded,
        onNeedsReinstall,
      }) {
        return function providesIntegrationDetailsOnError(response) {
          if (response.error) {
            const [error] = response.error.errors || []
            if (error.status && error.status === 401) {
              onNeedsReinstall()
            }
          }

          setActivityTargets([{ label: 'Select a #channel', value: '' }])
          setActivityTargetsLoaded(true)
        }
      },
    })
  )
}
